
import { Link } from "react-router-dom";
import { StoryCard } from "./StoryCard";
import { Loader2 } from "lucide-react";
import { useFeaturedStories } from "@/hooks/useFeaturedStories";

export const FeaturedStories = () => {
  const { stories, isLoading, error } = useFeaturedStories(8);

  return (
    <section className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold">Featured Stories</h2>
          <Link to="/browse" className="text-chapterly-purple hover:underline">
            View all
          </Link>
        </div>
        
        {isLoading ? (
          <div className="flex flex-col items-center justify-center py-12">
            <Loader2 className="h-8 w-8 animate-spin text-chapterly-purple mb-4" />
            <p className="text-gray-600">Loading featured stories...</p>
          </div>
        ) : error ? (
          <div className="text-center py-12">
            <p className="text-gray-600">Failed to load stories. Please try again later.</p>
          </div>
        ) : stories.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-600">No featured stories available at the moment.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {stories.map((story) => (
              <StoryCard key={story.id} story={story} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
